import {defineAsyncComponent} from "vue";
import {pick} from "xe-utils";

/**
 * 页面组件
 */
const routes = [
    {name: 'Home', title: '一键理万账，共生赢未来', component: defineAsyncComponent(() => import('@/views/Home.vue'))},
    {name: 'Voucher', title: '凭证列表', component: defineAsyncComponent(() => import('@/views/voucher/Index.vue'))},
    {
        name: 'VoucherForm',
        title: '凭证信息',
        component: defineAsyncComponent(() => import('@/views/voucher/VoucherForm.vue'))
    },
    {
        name: 'VoucherRecycleBinTable',
        title: '凭证回收站',
        component: defineAsyncComponent(() => import('@/views/voucher/VoucherRecycleBinTable.vue'))
    },
    {name: 'CheckList', title: '期末结转', component: defineAsyncComponent(() => import('@/views/checkout/CheckList.vue'))},
    {
        name: 'NewCheckout',
        title: '结账',
        component: defineAsyncComponent(() => import('@/views/newCheckout/NewCheckout.vue'))
    },
    {name: 'Checkout', title: '结账', component: defineAsyncComponent(() => import('@/views/checkout/Checkout.vue'))},
    {name: 'Account', title: '账套', component: defineAsyncComponent(() => import('@/views/setting/Account.vue'))},
    {name: 'Subject', title: '科目', component: defineAsyncComponent(() => import('@/views/setting/Subject.vue'))},
    {name: 'Initial', title: '期初', component: defineAsyncComponent(() => import('@/views/setting/Initial.vue'))},
    {
        name: 'VoucherWord',
        title: '凭证字',
        component: defineAsyncComponent(() => import('@/views/setting/VoucherWord.vue'))
    },
    {name: 'Currency', title: '币别', component: defineAsyncComponent(() => import('@/views/setting/Currency.vue'))},
    {name: 'CurrencyRate', title: '币别汇率', component: defineAsyncComponent(() => import('@/views/setting/CurrencyRate.vue'))},
    {
        name: 'AssistingAccounting',
        title: '辅助核算',
        component: defineAsyncComponent(() => import('@/views/setting/AssistingAccounting.vue'))
    },
    {
        name: 'PermissionSetting',
        title: '权限设置',
        component: defineAsyncComponent(() => import('@/views/setting/PermissionSetting.vue'))
    },
    {
        name: 'PersonalSetting',
        title: '个人设置',
        component: defineAsyncComponent(() => import('@/views/personal/PersonalSetting.vue'))
    },
    {
        name: 'DetailedAccounts',
        title: '明细账',
        component: defineAsyncComponent(() => import('@/views/accountbook/DetailedAccounts.vue'))
    },
    {
        name: 'GeneralLedger',
        title: '总账',
        component: defineAsyncComponent(() => import('@/views/accountbook/GeneralLedger.vue'))
    },
    {
        name: 'SubjectBalance',
        title: '科目余额',
        component: defineAsyncComponent(() => import('@/views/accountbook/SubjectBalance.vue'))
    },
    {
        name: 'SubjectSummary',
        title: '科目汇总',
        component: defineAsyncComponent(() => import('@/views/accountbook/SubjectSummary.vue'))
    },
    {
        name: 'MultiColumnLedger',
        title: '多栏账',
        component: defineAsyncComponent(() => import('@/views/accountbook/MultiColumnLedger.vue'))
    },
    {
        name: 'AgeAnalysis',
        title: '账龄分析表',
        component: defineAsyncComponent(() => import('@/views/accountbook/AgeAnalysis.vue'))
    },
    {
        name: 'AuxiliaryAccountingBalance',
        title: '辅助核算余额',
        component: defineAsyncComponent(() => import('@/views/accountbook/AuxiliaryAccountingBalance.vue'))
    },
    {
        name: 'AuxiliaryAccountingDetail',
        title: '辅助核算明细账',
        component: defineAsyncComponent(() => import('@/views/accountbook/AuxiliaryAccountingDetail.vue'))
    },
    {
        name: 'TimeSeries',
        title: '序时账',
        component: defineAsyncComponent(() => import('@/views/accountbook/TimeSeries.vue'))
    },
    {name: 'ReportView', title: '报表数据', component: defineAsyncComponent(() => import('@/views/report/ReportView.vue'))},
    {
        name: 'CashierAccount',
        title: '账户设置',
        component: defineAsyncComponent(() => import('@/views/cashier/CashierAccount.vue'))
    },
    {
        name: 'CashierIoType',
        title: '收支类别',
        component: defineAsyncComponent(() => import('@/views/cashier/CashierIoType.vue'))
    },
    {
        name: 'CashierJournal',
        title: '日记账',
        component: defineAsyncComponent(() => import('@/views/cashier/CashierJournal.vue'))
    },
    {
        name: 'InternalTransfer',
        title: '内部转账',
        component: defineAsyncComponent(() => import('@/views/cashier/InternalTransfer.vue'))
    },
    {
        name: 'FundsReport',
        title: '资金报表',
        component: defineAsyncComponent(() => import('@/views/cashier/FundsReport.vue'))
    },
    {name: 'CheckUp', title: '核对总账', component: defineAsyncComponent(() => import('@/views/cashier/CheckUp.vue'))},
    {name: 'Assets', title: '固定资产管理', component: defineAsyncComponent(() => import('@/views/assets/Assets.vue'))},
    {
        name: 'AssetsType',
        title: '固定资产类型',
        component: defineAsyncComponent(() => import('@/views/assets/AssetsType.vue'))
    },
    {
        name: 'AssetsDepreciationList',
        title: '折旧明细表',
        component: defineAsyncComponent(() => import('@/views/assets/AssetsDepreciationList.vue'))
    },
    {
        name: 'AssetsSummary',
        title: '固定资产汇总',
        component: defineAsyncComponent(() => import('@/views/assets/AssetsSummary.vue'))
    },
    {
        name: 'AssetsCheck',
        title: '固定资产核对总账',
        component: defineAsyncComponent(() => import('@/views/assets/AssetsCheck.vue'))
    },
    {
        name: 'AssetsDepreciationAudit',
        title: '固定资产及折旧审核表',
        component: defineAsyncComponent(() => import('@/views/assets/AssetsDepreciationAudit.vue'))
    },
    {
        name: 'AssetsDepreciationAdjustment',
        title: '资产折旧及纳税调整',
        component: defineAsyncComponent(() => import('@/views/assets/AssetsDepreciationAdjustment.vue'))
    },
    {
        name: 'OutputInvoice',
        title: '销项发票',
        component: defineAsyncComponent(() => import('@/views/invoice/OutputTabs.vue'))
    },
    {
        name: 'IncomeInvoice',
        title: '进项发票',
        component: defineAsyncComponent(() => import('@/views/invoice/IncomeTabs.vue'))
    },
    {
        name: 'InvoiceTask',
        title: '发票获取',
        component: defineAsyncComponent(() => import('@/views/invoice/InvoiceTaskList.vue'))
    },
    {
        name: 'InvoiceVoucherTemplate',
        title: '凭证设置',
        component: defineAsyncComponent(() => import('@/views/invoice/InvoiceVoucherTemplate.vue'))
    },
    {name: 'BakUp', title: '数据备份', component: defineAsyncComponent(() => import('@/views/setting/BakUp.vue'))},
    {name: 'CustomerUpload', title: '客户上传', component: defineAsyncComponent(() => import('@/views/setting/CustomerUpload.vue'))},
    {name: 'Salary', title: '薪资', component: defineAsyncComponent(() => import('@/views/salary/Salary.vue'))},
    {
        name: 'SalaryDetail',
        title: '薪资',
        component: defineAsyncComponent(() => import('@/views/salary/SalaryDetail.vue'))
    },
    {name: 'BiReport', title: '自定义报表', component: defineAsyncComponent(() => import('./views/report/BiReport.vue'))},
    {
        name: 'FeeDetailReport',
        title: '费用明细表',
        component: defineAsyncComponent(() => import('./views/report/FeeDetailReport.vue'))
    },
    {name: 'Sync', title: '旧账迁入', component: defineAsyncComponent(() => import('@/views/sync/Sync.vue'))},
    {name: 'Emp', title: '员工信息', component: defineAsyncComponent(() => import('@/views/salary/HrTable'))},
    {
        name: 'SocialSecurity',
        title: '保险设置',
        component: defineAsyncComponent(() => import('@/views/salary/SocialSecurity'))
    },
    {name: 'OutputStock', title: '出库单', component: defineAsyncComponent(() => import('@/views/stock/OutputStock.vue'))},
    {name: 'IncomeStock', title: '入库单', component: defineAsyncComponent(() => import('@/views/stock/IncomeStock.vue'))},
    {
        name: 'StockReport',
        title: '存货报表',
        component: defineAsyncComponent(() => import('@/views/stock/StockReport.vue'))
    },
    {
        name: 'SalaryVoucherTemplateList',
        title: '工资记账配置',
        component: defineAsyncComponent(() => import('@/views/salary/SalaryVoucherTemplateList.vue'))
    },
    {
        name: 'TaxCustomer',
        title: '客户信息',
        component: defineAsyncComponent(() => import('@/views/tax/TaxCustomer.vue'))
    },
    {
        name: 'TaxCustomerDetail',
        title: '税务客户详情',
        component: defineAsyncComponent(() => import('@/views/tax/TaxCustomerDetail.vue'))
    },
    {
        name: 'TaxDetailSmall',
        title: '税务详情(小规模)',
        component: defineAsyncComponent(() => import('@/views/tax/TaxDetailSmall.vue'))
    },
    {
        name: 'TaxDetailNormal',
        title: '税务详情(一般)',
        component: defineAsyncComponent(() => import('@/views/tax/TaxDetailNormal.vue'))
    },
    {
        name: 'TaxTypeManage',
        title: '税费种管理',
        component: defineAsyncComponent(() => import('@/views/tax/TaxTypeManage.vue'))
    },
    {
        name: 'TaxPayRecord',
        title: '税款缴税记录',
        component: defineAsyncComponent(() => import('@/views/tax/TaxPayRecord.vue'))
    },
    {
        name: 'TaxDeclarationList',
        title: '税务申报清册',
        component: defineAsyncComponent(() => import('@/views/tax/TaxDeclarationList.vue'))
    },
    {
        name: 'StampDuty',
        title: '印花税',
        component: defineAsyncComponent(() => import('@/views/tax/StampDuty.vue'))
    },
    {
        name: 'InvoiceGoods',
        title: '发票货物',
        component: defineAsyncComponent(() => import('@/views/tax/InvoiceGoods.vue'))
    },
    {
        name: 'Invoice',
        title: '发票',
        component: defineAsyncComponent(() => import('@/views/tax/Invoice.vue'))
    },
    {
        name: 'TaskList',
        title: '任务列表',
        component: defineAsyncComponent(() => import('@/views/tax/TaskList.vue'))
    },
    {
        name: 'InvoiceDetail',
        title: '发票详情',
        component: defineAsyncComponent(() => import('@/views/tax/InvoiceDetail.vue'))
    },
    {
        name: 'InvoiceCheck',
        title: '发票勾选',
        component: defineAsyncComponent(() => import('@/views/tax/InvoiceCheck.vue'))
    },
    {
        name: 'BusinessIncomeTax',
        title: '企业所得税',
        component: defineAsyncComponent(() => import('@/views/tax/BusinessIncomeTax.vue'))
    },
    {
        name: 'BalanceSheet',
        title: '资产负债表',
        component: defineAsyncComponent(() => import('@/views/tax/BalanceSheet.vue'))
    },
    {
        name: 'ChartCashFlow',
        title: '现金流量表',
        component: defineAsyncComponent(() => import('@/views/tax/ChartCashFlow.vue'))
    },
    {
        name: 'ProfitSheet',
        title: '利润表',
        component: defineAsyncComponent(() => import('@/views/tax/ProfitSheet.vue'))
    },
    {
        name: 'PersonTax',
        title: '个人所得税',
        component: defineAsyncComponent(() => import('@/views/tax/PersonTax.vue'))
    },
    {
        name: 'PersonTaxPay',
        title: '个人所得税缴费记录',
        component: defineAsyncComponent(() => import('@/views/tax/PersonTaxPay.vue'))
    },
    {
        name: 'PersonTaxDeclarationRecord',
        title: '个人所得税申报记录',
        component: defineAsyncComponent(() => import('@/views/tax/PersonTaxDeclarationRecord.vue'))
    },
    {
        name: 'DisabledFund',
        title: '残疾人就业保障金',
        component: defineAsyncComponent(() => import('@/views/tax/DisabledFund.vue'))
    },
    {
        name: 'WaterConstructionIncome',
        title: '水利建设专项收入',
        component: defineAsyncComponent(() => import('@/views/tax/WaterConstructionIncome.vue'))
    },
    {
        name: 'IncomeTaxAnalyze',
        title: '增值税纳税分析',
        component: defineAsyncComponent(() => import('@/views/tax/IncomeTaxAnalyze.vue'))
    },
    {
        name: 'TaxSocialSecurity',
        title: '社保',
        component: defineAsyncComponent(() => import('@/views/tax/TaxSocialSecurity.vue'))
    },
    {
        name: 'SocialSecurityStaff',
        title: '职工参保信息',
        component: defineAsyncComponent(() => import('@/views/tax/SocialSecurityStaff.vue'))
    },
    {
        name: 'SocialSecurityStaffDetail',
        title: '职工社保缴纳详情',
        component: defineAsyncComponent(() => import('@/views/tax/SocialSecurityStaffDetail.vue'))
    },
    {
        name: 'SocialSecurityStaffDetailList',
        title: '社保缴费明细列表',
        component: defineAsyncComponent(() => import('@/views/tax/SocialSecurityStaffDetailList.vue'))
    },
    {
        name: 'SocialSecurityDeclare',
        title: '社保申报记录',
        component: defineAsyncComponent(() => import('@/views/tax/SocialSecurityDeclare.vue'))
    },
    {
        name: 'SocialSecurityNoDeclare',
        title: '社保未申报记录',
        component: defineAsyncComponent(() => import('@/views/tax/SocialSecurityNoDeclare.vue'))
    },
    {
        name: 'SocialSecurityPay',
        title: '社保缴费记录',
        component: defineAsyncComponent(() => import('@/views/tax/SocialSecurityPay.vue'))
    },
    {
        name: 'TaxSummary',
        title: '税务汇总',
        component: defineAsyncComponent(() => import('@/views/tax/TaxSummary.vue'))
    },
    {
        name: 'PersonTaxDetail',
        title: '个人所得税明细',
        component: defineAsyncComponent(() => import('@/views/tax/PersonTaxDetail.vue'))
    },
    {
        name: 'StaffManage',
        title: '员工管理',
        component: defineAsyncComponent(() => import('@/views/tax/StaffManage.vue'))
    },
    {
        name: 'StaffEdit',
        title: '员工编辑',
        component: defineAsyncComponent(() => import('@/views/tax/StaffEdit.vue'))
    },
    {   name: 'RentAndUtilityStepForm',
        title: '租金水电设置',
        component: defineAsyncComponent(() => import('@/views/setting/RentAndUtilityStepForm.vue'))
    },
    {   name: 'WorkIndex',
        title: '首页',
        component: defineAsyncComponent(() => import('@/views/workbenches/Index.vue')),
    },
    {   name: 'CorpEmp',
        title: '员工管理',
        component: defineAsyncComponent(() => import('@/views/workbenches/CorpEmp.vue')),
    },
    {   name: 'AccountSetList',
        title: '账套',
        component: defineAsyncComponent(() => import('@/views/workbenches/AccountSetList.vue')),
    },
    // {   name: 'CheckAccountSets',
    //     title: '查账（内）',
    //     component: defineAsyncComponent(() => import('@/views/workbenches/CheckAccountSets.vue')),
    // },
    {   name: 'CheckAccountSetsExternal',
        title: '查账（外）',
        component: defineAsyncComponent(() => import('@/views/workbenches/CheckAccountSetsExternal.vue')),
    },
    {   name: 'CheckAccountReportExternal',
        title: '查账报告（外）',
        component: defineAsyncComponent(() => import('@/views/workbenches/CheckAccountReportExternal.vue')),
    },
    // {   name: 'CheckAccountReport',
    //     title: '查账报告（内）',
    //     component: defineAsyncComponent(() => import('@/views/workbenches/CheckAccountReport.vue')),
    // },
    {   name: 'CheckAccountSnapshotList',
        title: '查账报告',
        component: defineAsyncComponent(() => import('@/views/workbenches/CheckAccountSnapshotList.vue')),
    },
    {   name: 'CheckAccountReportSummary',
        title: '查账报告汇总',
        component: defineAsyncComponent(() => import('@/views/workbenches/CheckAccountReportSummary.vue')),
    },
    {   name: 'CheckAccountReviewList',
        title: '审核列表',
        component: defineAsyncComponent(() => import('@/views/workbenches/CheckAccountReviewList.vue')),
    },
    {   name: 'ProgressVoucher',
        title: '记账进度',
        component: defineAsyncComponent(() => import('@/views/workbenches/ProgressVoucher.vue')),
    },
    {   name: 'Corp',
        title: '部门及员工管理',
        component: defineAsyncComponent(() => import('@/views/workbenches/Corp.vue')),
    },
    {   name: 'Check',
        title: '审账',
        component: defineAsyncComponent(() => import('@/views/workbenches/Check.vue')),
    },
    {   name: 'LrSpaceReport',
        title: '利润空间表',
        component: defineAsyncComponent(() => import('@/views/report/LrSpaceReport.vue')),
    },
    {name: 'SalaryTab', title: '薪资', component: defineAsyncComponent(() => import('@/views/salary/SalaryTab.vue'))},
    {name: 'SalaryBonus', title: '全年一次性奖金', component: defineAsyncComponent(() => import('@/views/salary/SalaryBonus.vue'))},
    {name: 'SubjectBalanceCheck', title: '往来分析', component: defineAsyncComponent(() => import('@/views/checkout/SubjectBalanceCheck.vue'))},
]

/**
 * 菜单
 */
const MENUS = [
    {
        title: '首页',
        key: 'Home',
        icon: 'fi fi-home',
        public: true,
    },
    {
        title: '结账',
        key: 'NewCheckout',
        icon: 'fi fi-jz',
        auth: 'checkout-checkoutmanage-canview',
    },
    // {
    //     title: '税务',
    //     key: 'Tax',
    //     icon: 'fi fi-sw',
    //     children: [
    //         {
    //             title: '税务客户信息',
    //             key: 'TaxCustomer',
    //             auth: 'tax-customer-canview'
    //         },
    //         {
    //             title: '汇总',
    //             key: 'TaxSummary',
    //             auth: 'tax-collection-canview'
    //         },
    //     ]
    // },
    {
        title: '凭证',
        key: 'vouchers',
        icon: 'fi fi-pz',
        children: [
            {
                title: '新增凭证',
                key: 'VoucherForm',
                auth: 'voucher-vouchermanage-canedit'
            },
            {
                title: '凭证列表',
                key: 'Voucher',
                auth: 'voucher-vouchermanage-canview'
            },
            {
                title: '凭证回收站',
                key: 'VoucherRecycleBinTable',
                auth: 'voucher-vouchermanage-canview'
            },
        ]
    },
    {
        title: '账簿',
        key: 'AccountBook',
        icon: 'fi fi-zb',
        children: [
            {
                title: '明细账',
                key: 'DetailedAccounts',
                auth: 'accountbook-subsidiaryledger-canview',
            },
            {
                title: '总账',
                key: 'GeneralLedger',
                auth: 'accountbook-generalledger-canview',
            },
            {
                title: '科目余额表',
                key: 'SubjectBalance',
                auth: 'accountbook-trialbalance-canview',
            },
            {
                title: '科目汇总表',
                key: 'SubjectSummary',
                auth: 'accountbook-categorizedaccountssummary-canview',
            },
            {
                title: '序时账',
                key: 'TimeSeries',
                auth: 'accountbook-journal-canview',
            },
            {
                title: '多栏账',
                key: 'MultiColumnLedger',
                auth: 'accountbook-journal-canview',
            },
            {
                title: '核算项目明细账',
                key: 'AuxiliaryAccountingDetail',
                auth: 'accountbook-aasubsidiaryledger-canview',
            },
            {
                title: '核算项目余额表',
                key: 'AuxiliaryAccountingBalance',
                auth: 'accountbook-aatrialbalance-canview',
            },
            {
                title: '账龄分析表',
                key: 'AgeAnalysis',
                auth: 'accountbook-journal-canview',
            },
            {
                title: '往来款项清理',
                key: 'SubjectBalanceCheck',
                auth: 'accountbook-trialbalance-canview',
            }
        ]
    },
    {
        title: '报表',
        key: 'ReportList',
        icon: 'fi fi-bb',
        children: [
            {
                title: '费用明细表',
                key: 'FeeDetailReport',
                auth: 'report-custom-report-canview',
            },
            {
                title: '利润空间表',
                key: 'LrSpaceReport',
                auth: 'report-custom-report-canview',
            },
            // {
            //     title: '自定义报表',
            //     key: 'BiReport',
            //     auth: 'report-custom-report-canview',
            // }
        ]
    },
    {
        title: '出纳',
        key: 'funds',
        icon: 'fi fi-zj',
        children: [
            {
                title: '日记账',
                key: 'CashierJournal',
                auth: 'cash-cashjournal-canview',
            },
            {
                title: '内部转账',
                key: 'InternalTransfer',
                auth: 'cash-transfer-canview',
            },
            {
                title: '资金报表',
                key: 'FundsReport',
                auth: 'cash-report-canview',
            },
            {
                title: '核对总账',
                key: 'CheckUp',
                auth: 'cash-cdcheck-canview',
            },
            {
                title: '收支类别',
                key: 'CashierIoType',
                auth: 'cash-ietype-canview',
            },
            {
                title: '账户设置',
                key: 'CashierAccount',
                auth: 'cash-cdaccount-canview',
            }
        ]
    },
    {
        title: '工资',
        key: 'SalaryM',
        icon: 'fi fi-gz',
        children: [
            {
                title: '工资信息',
                key: 'SalaryTab',
                auth: 'salary-salarymanage-canview',
            },
            {
                title: '员工信息',
                key: 'Emp',
                auth: 'salary-employinfo-canview',
            },
            {
                title: '五险一金设置',
                key: 'SocialSecurity',
                auth: 'salary-insuranceset-canview',
            },
            {
                title: '工资记账配置',
                key: 'SalaryVoucherTemplateList',
                auth: 'salary-insuranceset-canview',
            },
        ]
    },
    {
        title: '发票',
        key: 'Invoice',
        icon: 'fi fi-fp',
        children: [
            {
                title: '销项发票',
                key: 'OutputInvoice',
                auth: 'invoice-output-canview',
            },
            {
                title: '进项发票',
                key: 'IncomeInvoice',
                auth: 'invoice-input-canview',
            },
            {
                title: '凭证设置',
                key: 'InvoiceVoucherTemplate',
                auth: 'invoice-invoicevouchertemplate-canview',
            },
            {
                title: '发票获取',
                key: 'InvoiceTask',
                auth: 'invoice-task-canview',
            }
        ]
    },
    {
        title: '资产',
        key: 'assets',
        icon: 'fi fi-gdzc',
        children: [
            {
                title: '固定资产管理',
                key: 'Assets',
                auth: 'fixedassets-fixedassets-card-canview',
            },
            {
                title: '固定资产类别',
                key: 'AssetsType',
                auth: 'fixedassets-fixedassettype-canview',
            },
            {
                title: '折旧明细表',
                key: 'AssetsDepreciationList',
                auth: 'fixedassets-depreciationledger-canview',
            },
            {
                title: '固定资产汇总',
                key: 'AssetsSummary',
                auth: 'fixedassets-fasummary-canview',
            },
            {
                title: '固定资产及折旧审核表',
                key: 'AssetsDepreciationAudit',
                auth: 'fixedassets-fixedassets-card-canview',
            },
            {
                title: '资产折旧及纳税调整',
                key: 'AssetsDepreciationAdjustment',
                auth: 'fixedassets-fixedassets-card-canview',
            }
            // ,
            // {
            //     title: '固定资产对账',
            //     key: 'AssetsCheck',
            //     auth: 'fixedassets-checkledger-canview',
            // }
        ]
    },
    {
        title: '库存',
        key: 'stock',
        icon: 'fi fi-kc',
        children: [
            {
                title: '出库单',
                key: 'OutputStock',
                auth: 'stock-outputstock-canview',
            },
            {
                title: '入库单',
                key: 'IncomeStock',
                auth: 'stock-incomestock-canview',
            },
            // {
            //     title: '存货报表',
            //     key: 'StockReport',
            //     auth: 'stock-incomestock-canview',
            // },
        ]
    },
    // {
    //     title: '期末结转',
    //     key: 'Checkout',
    //     icon: 'fi fi-qmjz',
    //     auth: 'checkout-checkoutmanage-canview',
    // },
    {
        title: '设置',
        key: 'Setting',
        icon: 'fi fi-sz',
        children: [
            // {
            //     title: '账套',
            //     key: 'Account',
            //     auth: 'setting-accountset-canview',
            // },
            {
                title: '科目',
                key: 'Subject',
                auth: 'setting-accountsubject-canview',
            },
            {
                title: '期初',
                key: 'Initial',
                auth: 'setting-initialbalance-canview',
            },
            {
                title: '辅助核算',
                key: 'AssistingAccounting',
                auth: 'setting-assistingaccount-canview',
            },
            {
                title: '币别',
                key: 'Currency',
                auth: 'setting-currency-canview',
            },
            {
                title: '凭证字',
                key: 'VoucherWord',
                auth: 'setting-vouchergroup-canview',
            },
            // {
            //     title: '权限设置',
            //     key: 'PermissionSetting',
            //     auth: 'setting-backup-canview',
            // },
            {
                title: '旧账迁入',
                key: 'Sync',
                auth: 'setting-sync-canview',
            },
            {
                title: '数据备份',
                key: 'BakUp',
                auth: 'setting-backup-canview',
            },
            {
                title: '客户上传',
                key: 'CustomerUpload',
                auth: 'setting-backup-canview',
            }
        ]
    }
];


export const routeList = routes

export const menuList = MENUS

/**
 * 生成用户菜单
 * @param astAdmin 是否是管理员
 * @param authorities 权限集
 */
export const generateUserMenu = (astAdmin = false, authorities = []) => {
    if (astAdmin) {
        return MENUS;
    }
    let userMenu = [];
    for (let menu of MENUS) {
        if (menu.public) {
            userMenu.push(menu)
        } else if (menu.hasOwnProperty("auth")) {
            authorities.includes(menu.auth) && userMenu.push(menu);
        } else {
            let children = menu.children.filter(val => authorities.includes(val.auth));
            if (children.length) {
                userMenu.push(Object.assign(pick(menu, ['title', 'key', 'icon']), {children}))
            } else if (menu.key === 'ReportList' && authorities.some(a => a.startsWith("report"))) {
                userMenu.push(Object.assign(pick(menu, ['title', 'key', 'icon']), {children}))
            }
        }
    }
    return userMenu;
}

export default {
    install(vue) {
        //注册页面
        routes.forEach(item => vue.component(item.name, item.component))
    }
}
